import { useState, useEffect } from 'react';

export default function ComingSoon() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-purple-50 flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="max-w-4xl w-full text-center">
        {/* Construction Animation */}
        <div className="relative mb-6 sm:mb-8 lg:mb-12">
          <div className="flex justify-center items-end space-x-2 sm:space-x-3 lg:space-x-4 mb-4 sm:mb-6">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="relative"
                style={{
                  animation: `float 2s ease-in-out ${i * 0.3}s infinite`
                }}
              >
                <div
                  className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 rounded-lg shadow-lg"
                  style={{
                    backgroundColor: '#7E57C2',
                    opacity: 0.9 - (i * 0.15)
                  }}
                />
              </div>
            ))}
          </div>

          {/* Crane Hook */}
          <div className="flex justify-center">
            <div
              className="w-0.5 sm:w-1 h-16 sm:h-24 lg:h-32 origin-top"
              style={{
                backgroundColor: '#7E57C2',
                animation: 'swing 3s ease-in-out infinite'
              }}
            >
              <div
                className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 rounded-full border-4 sm:border-4 lg:border-[5px] absolute -bottom-3 sm:-bottom-4 lg:-bottom-5 left-1/2 -translate-x-1/2"
                style={{ borderColor: '#7E57C2' }}
              />
            </div>
          </div>
        </div>

        {/* Logo/Brand */}
        <div className="mb-4 sm:mb-6 lg:mb-8">
          <h1
            className="text-4xl sm:text-6xl lg:text-7xl font-bold mb-2 sm:mb-3"
            style={{ color: '#7E57C2' }}
          >
            Jellopages
          </h1>
          <div className="h-1 sm:h-1.5 w-24 sm:w-32 lg:w-40 mx-auto rounded-full" style={{ backgroundColor: '#7E57C2' }} />
        </div>

        {/* Coming Soon Text */}
        <div className="mb-6 sm:mb-8 lg:mb-10">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-800 mb-2 sm:mb-3 lg:mb-4">
            Coming Soon{dots}
          </h2>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        @keyframes swing {
          0%, 100% { transform: rotate(-5deg); }
          50% { transform: rotate(5deg); }
        }

        @keyframes progress {
          0%, 100% { width: 65%; }
          50% { width: 80%; }
        }
      `}</style>
    </div>
  );
}